import SmartFallbackLoader from './smart-fallback-loader';

export default SmartFallbackLoader;
